function p(p,d,e,t){p._m(d);var u=e("27ed32d1");p._(d,"AppRoutes",u),p._(d,"default",u,"App");}